/* globals google */
import { loadContent } from '../util/fetchutils'; // eslint-disable-line
import { replaceUrlParams } from '../../../../scripts/helpers/urlHelpers';

const DEFAULT_COORDS = { lat: 0, long: 0 };

const getLatLong = (address, country) => {
  const geocoder = new google.maps.Geocoder();
  return new Promise((resolve) => {
    const params = { address };

    if (country) {
      params.componentRestrictions = { country };
    }

    geocoder.geocode(params, (results, status) => {
      if (status === 'OK') {
        const lat = results[0].geometry.location.lat();
        const long = results[0].geometry.location.lng();

        const coodrs = { lat, long };

        return resolve(coodrs);
      }

      return resolve(DEFAULT_COORDS);
    });
  });
};

const getPosition = () => new Promise(((resolve, reject) => {
  if (!navigator.geolocation) {
    reject();
  } else {
    navigator.geolocation.getCurrentPosition(async position => resolve(position));
  }
}));

const search = async (form, url, coords) => {
  // Adding coords to action url in order to use them for the filter logic
  const updatedUrl = replaceUrlParams(url, coords);
  form.setAttribute('action', updatedUrl);

  const { content } = await loadContent(form, null, coords);

  return content;
};

// eslint-disable-next-line import/prefer-default-export
export const searchStores = async (form, trigger) => {
  let coords = DEFAULT_COORDS;
  const url = form.getAttribute('action');

  if (trigger && trigger.classList.contains('detect-location')) {
    const position = await getPosition();

    coords = {
      lat: position.coords.latitude,
      long: position.coords.longitude,
    };
  } else {
    const address = form.querySelector('[name="postalCode"]').value;

    const countryField = form.querySelector('[name$="_country"]');
    const country = countryField ? countryField.value : '';

    try {
      coords = await getLatLong(address, country);
    } catch (e) {
      // Fallback to 0, 0
    }
  }

  return search(form, url, coords);
};
